import request from '@/utils/request'
/**
 * 登录
 * @param {*} username 
 * @param {*} password 
 */
function login(username, password) {
  const data = {
    loginname: username,
    loginpwd: password
  }
  return request({
    url: '/login/login',
    method: 'POST',
    data
  })
}
/**
 * 修改密码
 * @param {*} data 
 */
function changedpwd(data){
  return request({
    url: '/login/changedpwd',
    method: 'put',
    data
  })
}
function logout() {
  return request({
    url: 'login/logout',
    method: 'post'
  })
}
function getUserInfo() {
  return request({
    url: 'user/getCurrentUser',
    method: 'get'
  })
}
/**
 * 获取用户权限菜单
 */
function getRoutes() {
  return request({
    url: 'user/getUserMenu',
    method: 'get'
  })
}

export { login, changedpwd,logout, getUserInfo, getRoutes }
